import { Box, Heading, Text, Spinner } from "@chakra-ui/react";
import "./style.css";
import Carlota from "../../images/coaches/carlota_provenzali.webp";
import ScrollContainer from "react-indiana-drag-scroll";
import { useEffect, useState } from "react";
import axios from "axios";
import { Coach } from "./CoachCard";
import { useTranslation } from "react-i18next";

export function Coaches(props) {
  const [coaches, setCoaches] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const { data } = await axios.get("/api/coaches");
      const allCoaches = [
        ...data,
        {
          id: 0,
          coachName: "Carlota Provenzali",
          titleKey: "coaches.carlota.title",
          descriptionKey: "coaches.carlota.description",
          avatar: Carlota,
          link: "https://www.instagram.com/carlota_nutri/",
          tagsKey: "coaches.carlota.tags",
        },
      ];
      setCoaches(allCoaches);
    })();
  }, []);

  return (
    <Box /*bg="gray.800"*/>
      <Heading
        fontFamily={"Oswald"}
        fontWeight={400}
        fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
        lineHeight={"110%"}
        color={"gray.800"}
        pt={3}
        px={4}
        pb={8}
        textAlign={"center"}
      >
        {t("coaches.headingPrefix")}
        <Text
          as={"span"}
          color={"blue.500"}
          display={{ base: "block", sm: "inline" }}
        >
          {" "}
          {t("coaches.headingEmphasis")}
        </Text>
      </Heading>

      <div id="my-carousel" className="coach-carousel">
        <ScrollContainer className="coach-container">
          <div className="coach-carousel-content">
            {coaches ? (
              coaches.map((coach) => (
                <Coach
                  key={coach.id}
                  coachName={coach.coachName}
                  coachTitle={
                    coach.titleKey ? t(coach.titleKey) : coach.title
                  }
                  coachDescription={
                    coach.descriptionKey
                      ? t(coach.descriptionKey)
                      : coach.description
                  }
                  coachImage={coach.avatar}
                  coachLink={coach.link} // TO BE DONE: endpoint does not return link
                  coachTrainings={coach.tagsKey ? t(coach.tagsKey) : coach.tags}
                />
              ))
            ) : (
              <Spinner size="xl" m={10}/>
            )}
            <div className="clear-fix">&nbsp;</div>
          </div>
        </ScrollContainer>
      </div>
    </Box>
  );
}
